/** How many steps over the grid each tile is from a start: the grass ring around the player, the lab's specimens. */
import type { Grid } from '@bramvasterd/terrella-rules';

/**
 * Steps from `start` to every tile within `limit`; -1 beyond (and everywhere for no start). Pass
 * `out` and `queue` to reuse them instead of making new ones.
 */
export function stepsFrom(
  grid: Grid,
  start: number,
  limit: number,
  out = new Int32Array(grid.count),
  queue: number[] = [],
): Int32Array {
  out.fill(-1);
  queue.length = 0;
  if (start < 0 || start >= grid.count) return out;
  out[start] = 0;
  queue.push(start);
  // the queue grows while it is walked: every tile reached is visited in turn
  for (const i of queue) {
    const s = out[i] ?? 0;
    if (s >= limit) continue;
    for (const j of grid.neighbors[i] ?? []) {
      if ((out[j] ?? 0) < 0) {
        out[j] = s + 1;
        queue.push(j);
      }
    }
  }
  return out;
}
